import { NgxSpinnerService } from 'ngx-spinner';
import { state } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from './../../../../../../core/toast.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormArray, AbstractControl } from '@angular/forms';
import { GetSupplyBrandService } from '../../services/get-supply-brand.service';
import { GetSupplyCategoryService } from '../../services/get-supply-category.service';
import { GetSupplySubCategoryService } from '../../services/get-supply-sub-category.service';
import { SecondHandSupply } from '../../models/second-hand-supply';
import { AddSecondHandSupplyService } from '../../services/add-second-hand-supply.service';
import { GetPriceUnitService } from '../../services/get-price-unit.service';
import { UpdateSecondHandSupplyService } from '../../services/update-second-hand-supply.service';
import { AddSupplySubCategoryComponent } from '../../components/add-supply-sub-category/add-supply-sub-category.component';
import { AddPriceUnitComponent } from '../../components/add-price-unit/add-price-unit.component';
import { AddSupplyBrandComponent } from '../../components/add-supply-brand/add-supply-brand.component';
import { AddSupplyCategoryComponent } from '../../components/add-supply-category/add-supply-category.component';
import { StatesService } from '../../services/states.service';
import { MetroRegionsService } from '../../services/metro-regions.service';
import { SuburbansService } from '../../services/suburbans.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {
  editorConfig: AngularEditorConfig = {
    minHeight: '100',
  };
  currentDate = new Date();
  secondHandSupplyForm = this.fb.group({
    id: [null],
    supply_category_id: [null],
    //supply_category_id: [null, [Validators.required]],
    supply_sub_category_id: [null],
    //supply_sub_category_id: [null, [Validators.required]],
    supply_brand_id: [null],
    //supply_brand_id: [null, [Validators.required]],
    title: [null],
    description: [null],
    image: [null, [Validators.required]],
    video: [null, []],
    more_images: [null, []],
    product_type: ["BOTH", [Validators.required]],
    starting_price: [null, [Validators.required]],
    price_unit: [null, []],
    buy_now_price: [null, [Validators.required]],
    bid_ends_at: [null, [Validators.required]],
    bid_starts_at: [null, [Validators.required]],
    status: ['DRAFT', [Validators.required]],
    is_featured: [false, [Validators.required]],

    sku: [null, [Validators.required]],
    color: [null, []],
    specifications: [null],
    seo_metadata: this.fb.group({
      title: [null, []],
      image: [null, []],
      alt_text: [null, []],
      keywords: [null, []],
      description: [null, []]
    }),
    product_status: ['ACTIVE', [Validators.required]],
    freight_charge: this.fb.group({
      type: ['RANGE', [Validators.required]],
      state_id: [null, [Validators.required]],
      metro_regions: this.fb.array([this.getMetroRegion()]),
      amount: [null, []],
      address: this.fb.group({
        short_name : [null, []],
        line_1 : [null, []],
        line_2 : [null, []],
        landmark : [null, []],
        city: [null, []],
        state: [null, []],
        country: ['Australia', []],
        postal_code: [null, []],
        latitude: [0, []],
        longitude : [0, []],
        google_place_id: ["PLACE_ID123"]
      })
    })
  })


  supplyCategoryList: any[];
  supplySubCategoryList: any[];
  supplyBrandList: any[];
  priceUnitList: any[];
  subCategoryFilterCtrl = this.fb.control(null);
  categoryFilterCtrl = this.fb.control(null);
  brandFilterCtrl = this.fb.control(null);
  priceUnitFilterCtrl = this.fb.control(null);
  @ViewChild('keywordInput') keywordInputRef: ElementRef<HTMLInputElement>;
  removable = true;
  oldSecondHandSupply: SecondHandSupply;
  suburbanList: any[];
  stateList: any[];
  metroRegionList: any[];
  constructor(
    private fb: FormBuilder,
    private getSupplyCategoryService: GetSupplyCategoryService,
    private getSupplySubCategoryService: GetSupplySubCategoryService,
    private getSupplyBrandService: GetSupplyBrandService,
    private getPriceUnitService: GetPriceUnitService,
    private toast: ToastService,
    private addSecondHandSupplyService: AddSecondHandSupplyService,
    private updateSecondHandSupplyService: UpdateSecondHandSupplyService,
    private route: ActivatedRoute,
    private router: Router,
    private matDialog: MatDialog,
    private statesService: StatesService,
    private metroRegionsService: MetroRegionsService,
    private suburbansService: SuburbansService,
    private spinner: NgxSpinnerService
  ) {
  }
  ngOnInit(): void {
    if (this.route.snapshot.data && this.route.snapshot.data.oldSecondHandSupply) {
      this.oldSecondHandSupply = this.route.snapshot.data.oldSecondHandSupply;
      if (this.oldSecondHandSupply.freight_charge.type === 'RANGE') {
        this.oldSecondHandSupply.freight_charge.metro_regions.forEach(() => {
          this.plusMetroRegion();
        });
      }
      this.setCustomValidity(this.oldSecondHandSupply.product_type);
      this.setFrightTypeValidity(this.oldSecondHandSupply.freight_charge.type);
      this.secondHandSupplyForm.patchValue(this.oldSecondHandSupply);
    }
    this.getSupplyCategoryService.getSupplyCategory().subscribe((data: any) => {
      this.supplyCategoryList = data;
    });
    this.getSupplySubCategoryService.getSupplySubCategory().subscribe((data: any) => {
      this.supplySubCategoryList = data;
    });
    this.getSupplyBrandService.getSupplyBrand().subscribe((data: any) => {
      this.supplyBrandList = data;
    });
    this.getPriceUnitService.getPriceUnit().subscribe((data: any) => {
      this.priceUnitList = data;
    });
    this.statesService.getStates().subscribe((data: any[]) => {
      this.stateList = data;
    })
    this.metroRegionsService.getMetroRegions().subscribe((data: any[]) => {
      this.metroRegionList = data;
    })
    this.suburbansService.getSuburbans().subscribe((data: any[]) => {
      this.suburbanList = data;
      console.log(data)
    });
    this.product_type.valueChanges.subscribe(type => {
      this.setCustomValidity(type);
    });

    this.type.valueChanges.subscribe(type =>{
      this.setFrightTypeValidity(type);
    });
  }
  async addSupply(status: string) {
    this.status.setValue(status);
    if (this.secondHandSupplyForm.invalid) {
      this.toast.openSnackBar('Please enter valid details');
      this.secondHandSupplyForm.markAllAsTouched();
      return;
    }
    this.spinner.show();
    const secondHandSupply = this.secondHandSupplyForm.value as SecondHandSupply;
    if (this.idValue) {
      try {
        const response = await this.updateSecondHandSupplyService.updateSecondHandSupplyByPk(this.idValue, secondHandSupply);
        this.spinner.hide();
        this.toast.openSnackBar('Pre owned supplies updated successfully');
        this.router.navigate(['../../list'], { relativeTo: this.route });
      } catch (error) {
        this.spinner.hide();
        this.toast.openSnackBar('Unable to update pre owned supplies');
      }
    } else {
      try {
        const response = await this.addSecondHandSupplyService.addSecondHandSupply(secondHandSupply);
        this.spinner.hide();
        this.toast.openSnackBar('Pre owned supplies added successfully');
        this.router.navigate(['../list'], { relativeTo: this.route });
      } catch (error) {
        this.spinner.hide();
        this.toast.openSnackBar('Unable to add pre owned supplies');
      }
    }
  }
  get idValue() {
    return this.id.value;
  }
  get id() {
    return this.secondHandSupplyForm.get('id');
  }
  get supply_category_id() {
    return this.secondHandSupplyForm.get('supply_category_id');
  }
  get supply_sub_category_id() {
    return this.secondHandSupplyForm.get('supply_sub_category_id');
  }
  get supply_brand_id() {
    return this.secondHandSupplyForm.get('supply_brand_id');
  }
  get title() {
    return this.secondHandSupplyForm.get('title');
  }
  get specifications() {
    return this.secondHandSupplyForm.get('specifications');
  }
  get description() {
    return this.secondHandSupplyForm.get('description');
  }
  get status(){
    return this.secondHandSupplyForm.get('status');
  }
  get sku() {
    return this.secondHandSupplyForm.get('sku');
  }
  get color() {
    return this.secondHandSupplyForm.get('color');
  }
  get image() {
    return this.secondHandSupplyForm.get('image');
  }
  get video() {
    return this.secondHandSupplyForm.get('video');
  }
  get more_images() {
    return this.secondHandSupplyForm.get('more_images');
  }
  get product_type() {
    return this.secondHandSupplyForm.get('product_type');
  }
  get starting_price() {
    return this.secondHandSupplyForm.get('starting_price');
  }
  get price_unit() {
    return this.secondHandSupplyForm.get('price_unit');
  }
  get buy_now_price() {
    return this.secondHandSupplyForm.get('buy_now_price');
  }
  get bid_starts_at() {
    return this.secondHandSupplyForm.get('bid_starts_at');
  }
  get bid_ends_at() {
    return this.secondHandSupplyForm.get('bid_ends_at');
  }
  get is_featured() {
    return this.secondHandSupplyForm.get('is_featured');
  }
  get seo_metadata(): FormGroup {
    return this.secondHandSupplyForm.get('seo_metadata') as FormGroup;
  }
  get seo_title() {
    return this.seo_metadata.get('title');
  }
  get seo_image() {
    return this.seo_metadata.get('image');
  }
  get seo_alt_text() {
    return this.seo_metadata.get('alt_text');
  }
  get seo_keywords() {
    return this.seo_metadata.get('keywords');
  }
  get seo_description() {
    return this.seo_metadata.get('description');
  }
  get freightRangeForm(): FormGroup {
    return this.secondHandSupplyForm.get('freight_charge') as FormGroup;
  }
  get type() {
    return this.freightRangeForm.get('type');
  }
  get state_id() {
    return this.freightRangeForm.get('state_id');
  }
  get metro_regions(): FormArray {
    return this.freightRangeForm.get('metro_regions') as FormArray;
  }
  getName(i: number) {
    return this.metro_regions.controls[i].get('name');
  }
  getPincodes(i: number) {
    return this.metro_regions.controls[i].get('pincodes');
  }
  getAmount(i: number) {
    return this.metro_regions.controls[i].get('amount');
  }
  get amount() {
    return this.freightRangeForm.get('amount');
  }

  get address(){
    return this.freightRangeForm.get('address');
  }


  get address_type(){
   return this.address.get('type');
 }

  get short_name(){
    return this.address.get('short_name');
  }

  get line_1(){
    return this.address.get('line_1');
  }

  get line_2(){
    return this.address.get('line_2')
  }

  get landmark(){
    return this.address.get('landmark')
  }

  get city(){
    return this.address.get('city');
  }

  get state(){
    return this.address.get('state')
  }

  get country(){
    return this.address.get('country');
  }

  get postal_code(){
    return this.address.get('postal_code');
  }

  get latitude(){
    return this.address.get('latitude');
  }

  get longitude(){
    return this.address.get('longitude');
  }

  get google_place_id(){
   return this.address.get('google_place_id');
  }

  get make_default(){
    return this.address.get('make_default');
  }


  getMetroRegion() {
    return this.fb.group({
      name: [null, [Validators.required]],
      pincodes: [null],
      amount: [null, [Validators.required]]
    });
  }
  plusMetroRegion() {
    this.metro_regions.push(this.getMetroRegion());
  }
  minusMetroRegion(i: number) {
    this.metro_regions.removeAt(i);
  }
  /* ------------------------------ Save Keyword ------------------------------ */
  saveKeyword(ev: KeyboardEvent) {
    if (ev.key === "Enter") {
      const value = this.keywordInputRef.nativeElement.value;
      if (value) {
        if (this.seo_keywords.value) {
          this.seo_keywords.value.push(value);
        } else {
          this.seo_keywords.setValue([value]);
        }
      }
      this.seo_keywords.updateValueAndValidity();
      this.keywordInputRef.nativeElement.value = "";
      return false;
    } else {
      return true;
    }
  }
  remove(ev: any) {
    this.seo_keywords.setValue(this.seo_keywords.value.filter((single: any) => single !== ev));
  }
  addSupplyCategoryDialog() {
    const dialogRef = this.matDialog.open(AddSupplyCategoryComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: { name: this.categoryFilterCtrl.value }
    })
    dialogRef.afterClosed().subscribe(data => {
      if (data instanceof Object) {
        this.categoryFilterCtrl.setValue(null);
        this.supplyCategoryList.push(data);
        this.supply_category_id.setValue(data.id);
      }
    });
  }
  addPriceUnitDialog() {
    const dialogRef = this.matDialog.open(AddPriceUnitComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: { name: this.priceUnitFilterCtrl.value }
    })
    dialogRef.afterClosed().subscribe(data => {
      if (data instanceof Object) {
        this.priceUnitFilterCtrl.setValue(null);
        this.priceUnitList.push(data);
        this.price_unit.setValue(data.name);
      }
    });
  }
  addSupplySubCategoryDialog() {
    const dialogRef = this.matDialog.open(AddSupplySubCategoryComponent, {
      width: '50%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: { name: this.subCategoryFilterCtrl.value, supply_category_id: this.supply_category_id.value }
    })
    dialogRef.afterClosed().subscribe(data => {
      if (data instanceof Object) {
        this.subCategoryFilterCtrl.setValue(null);
        this.supplySubCategoryList.push(data);
        this.supply_sub_category_id.setValue(data.id);
      }
    });
  }
  addSupplyBrandDialog() {
    const dialogRef = this.matDialog.open(AddSupplyBrandComponent, {
      width: '50%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: { name: this.brandFilterCtrl.value }
    })
    dialogRef.afterClosed().subscribe(data => {
      if (data instanceof Object) {
        this.brandFilterCtrl.setValue(null);
        this.supplyBrandList.push(data);
        this.supply_brand_id.setValue(data.id);
      }
    });
  }
  setCustomValidity(type: string) {
    console.log(type);
    if(type === "ONLY_BIDING"){
      this.bid_starts_at.setValidators([Validators.required]);
      this.bid_ends_at.setValidators([Validators.required]);
      this.starting_price.setValidators([Validators.required]);
      this.buy_now_price.setValidators(null);
    }
    if(type === "ONLY_BUY_NOW"){
      this.bid_starts_at.setValidators(null);
      this.bid_ends_at.setValidators(null);
      this.starting_price.setValidators(null);
      this.buy_now_price.setValidators([Validators.required]);
    }
    if(type === "BOTH"){
      this.bid_starts_at.setValidators([Validators.required]);
      this.bid_ends_at.setValidators([Validators.required]);
      this.starting_price.setValidators([Validators.required]);
      this.buy_now_price.setValidators([Validators.required]);
    }
    this.bid_starts_at.updateValueAndValidity();
    this.bid_ends_at.updateValueAndValidity();
    this.starting_price.updateValueAndValidity();
    this.buy_now_price.updateValueAndValidity();
  }

  setFrightTypeValidity(type: string) {
    if(type === "RANGE"){
      this.state_id.setValidators([Validators.required]);
      this.metro_regions.clear();
      this.plusMetroRegion();
      this.short_name.setValidators(null);
      this.line_1.setValidators(null);
      this.city.setValidators(null);
      this.state.setValidators(null);
      this.country.setValidators(null);
      this.postal_code.setValidators(null);
      this.amount.setValidators(null);
    }

    if(type === "FLAT"){
      this.state_id.setValidators(null);
      this.metro_regions.clear();
      this.short_name.setValidators(null);
      this.line_1.setValidators(null);
      this.city.setValidators(null);
      this.state.setValidators(null);
      this.country.setValidators(null);
      this.postal_code.setValidators(null);
      this.amount.setValidators([Validators.required]);
    }

    if(type === "PICKUP"){
      this.state_id.setValidators(null);
      this.metro_regions.clear();
      this.short_name.setValidators([Validators.required]);
      this.line_1.setValidators([Validators.required]);
      this.city.setValidators([Validators.required]);
      this.state.setValidators([Validators.required]);
      this.country.setValidators([Validators.required]);
      this.postal_code.setValidators([Validators.required]);
      this.amount.setValidators(null);
    }

    this.state_id.updateValueAndValidity();
    this.short_name.updateValueAndValidity();
    this.line_1.updateValueAndValidity();
    this.city.updateValueAndValidity();
    this.state.updateValueAndValidity();
    this.country.updateValueAndValidity();
    this.postal_code.updateValueAndValidity();
    this.amount.updateValueAndValidity();
  }

  trimMe(ac: AbstractControl){
    ac.setValue(ac.value.trim());
  }

  togglePerOne(ac:AbstractControl, suburbanList:any, allSelected: any): any{
    console.log(ac.value);
    if(ac.value.length == suburbanList.length){
      allSelected.select();
    } else {
      allSelected.deselect();
      return false;
    }
  }
   toggleAllSelection(ac: AbstractControl, suburbanList:any, allSelected: any) {
     if (allSelected.selected) {
       ac.patchValue([...suburbanList.map(item => item.pincode), 0]);
     } else {
       ac.patchValue([]);
     }
   }
}
